<template>
  <Modal class-name="vertical-center-modal" v-model="isModal" title="提示" width="360">
    <div class="form-wrapper">
      <div class="tip-wrap" v-if="type == 1">
        <div>是否将该笔提现状态改为：“待打款”？</div>
        <div class="color-ff9 padding-t-20">注：仅修改状态，不进行打款操作</div>
      </div>
      <div class="tip-wrap" v-if="type == 2">
        <div>是否对该笔提现进行打款操作？</div>
      </div>
    </div>
    <div slot="footer">
      <div class="footer-wrapper">
        <span class="btn confirm-btn" @click="handelSubmit">确定</span>
      </div>
    </div>
    <Spin size="large" fix v-show="loading"></Spin>
  </Modal>
</template>

<script>
  import { Modal, Spin } from 'view-design'
  import commission from '@/javaApi/commission'
  const commissionModel = new commission()
  import { getPlatformUuid } from '@/utils/auth'
  export default {
    name: "Audit",
    components: {
      Modal,
      Spin
    },
    data: function() {
      return {
        isModal: false,
        loading: false,
        type: 1,
        withdraw_id: '',
        platformUuid:getPlatformUuid(),
        isPay:false, //禁止重复点击
      }
    },
    methods: {
      init: function(isModal, id, type) {
        this.loading = true
        this.isModal = isModal
        this.type = type
        this.withdraw_id = id
        this.loading = false
      },
      handelSubmit:function(){
        console.log(this.isPay)
        if(!this.isPay){
          this.isPay = true
          if(this.type == 1){
            commissionModel.auditWithdraw({id:this.withdraw_id}).then((response) => {
              var res = response.data
              if(res.code != 200){
                this.$Message.error(res.message?res.message:'系统异常请稍后再试！')
                return
              }
              this.$Message.success('操作成功！');
              this.isModal = false;
              this.isModal = false;
              this.$emit('refreshList');
            })
          }else if(this.type == 2){
            this.isPay = true
            commissionModel.remitWithdraw({userWithDrawAuditId:this.withdraw_id,platformUuid:this.platformUuid}).then((response)=>{
              var res = response.data
              if(res.code != 200){
                this.$Message.error(res.message?res.message:'系统异常请稍后再试！')
                return
              }
              this.$Message.success('操作成功！');
              this.isModal = false;
              this.$emit('refreshList');
              this.isPay = true
            })
          }
        }else {
          return
        }
      }
    }
  }
</script>

<style scoped>
  >>>.vertical-center-modal {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  >>>.vertical-center-modal .ivu-modal {
    top: 0;
    width: 300px;
  }

  >>>.vertical-center-modal .ivu-modal-footer {
    border-top: none;
    padding: 12px 18px 12px 18px;
    text-align: right;
  }
  .form-wrapper .tip-wrap{
    padding: 20px;
  }
  .footer-wrapper {
    display: flex;
    min-width: 0;
    width: 100%;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
  }

  .footer-wrapper .btn {
    display: inline-block;
    border-radius: 4px;
    margin-right: 10px;
    padding: 0px 15px;
    font-size: 14px;
    height: 32px;
    line-height: 32px;
    vertical-align: middle;
    cursor: pointer;
  }

  .footer-wrapper .btn.confirm-btn {
    background: #ff8622;
    color: #fff;
  }

  .footer-wrapper .btn.cancel-btn {
    border: 1px solid #eeeeee;
    border-radius: 2px;
    color: #222222;
  }
</style>



// WEBPACK FOOTER //
// src/views/pc/official/commission/modal/Audit.vue